import {get, postImport, put} from "./index";

export const validateImportCenterFile = async (entityName, body, toast) => {
  return put("/import/valid/" + entityName, body, undefined, toast);
};

export const importFile = async (entityName, body, toast) => {
  return postImport("/import/" + entityName, body, undefined, toast);
};

export const getImportCenterConfig = async (toast) => {
  return get("/import/import-config", undefined, undefined, toast);
};
